'use strict';

class Slider {

    constructor() {

        this.logoSlider();
        this.quoteSlider();
        this.instagramPosts();
        this.pricingSlider();
        this.reviewsSlider();
        this.topArticlesSlider();

    }

    async logoSlider() {
        let logoSliders = document.querySelectorAll( '.ce-customer-logo-grid' );

        if ( logoSliders.length > 0 ) {
            const {Swiper, Autoplay} = await import( 'swiper' );
            
            for ( let slider of logoSliders ) {
                new Swiper( slider.querySelector( '.swiper' ), {
                    modules: [Autoplay],
                    speed: 3000,
                    loop: true,
                    loopedSlides: 10,
                    loopedSlidesLimit: false,
                    slidesPerView: 'auto',
                    spaceBetween: 64,
                    allowTouchMove: false,
                    autoplay: {
                        delay: 0,
                    }
                } ) 
            }

        }

    }

    async quoteSlider() {

        let quoteSlider = document.querySelectorAll( '.ce-quote-slider' );

        if ( quoteSlider.length > 0 ) {
            const {Swiper, Navigation} = await import( 'swiper' );

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for ( let slider of quoteSlider ) {

                new Swiper( slider.querySelector( '.swiper' ), {
                    modules: [Navigation],
                    navigation: {
                        nextEl: slider.querySelector( '.swiper-button-next' ),
                        prevEl: slider.querySelector( '.swiper-button-prev' )
                    },
                    spaceBetween: 32,
                    slidesPerView: 1,
                    speed: 600,
                    watchOverflow: true
                } );

            }

        }

    }

    async instagramPosts() {

        let instagramSlider = document.querySelectorAll( '.ce-instagram' );

        if ( instagramSlider.length > 0 ) {
            const {Swiper} = await import( 'swiper' );

            for ( let slider of instagramSlider ) {

                new Swiper( slider.querySelector( '.swiper' ), {
                    speed: 800,
                    simulateTouch: true,
                    slidesPerView: 3,
                    watchOverflow: true,
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 4,
                        },
                    },

                } );

            }

        }

    }

    async pricingSlider() {

        let pricingSlider = document.querySelectorAll( '.pricing-slider' );

        if ( pricingSlider.length > 0 ) {
            const {Swiper, Pagination} = await import( 'swiper' );

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for ( let slider of pricingSlider ) {

                let pricingSliderInstance = new Swiper( slider.querySelector( '.swiper' ), {
                    modules: [Pagination],
                    slidesPerView: 1.25,
                    spaceBetween: 24,
                    centeredSlides: true,
                    speed: 600,
                    watchOverflow: true,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    initialSlide: 1, // = index; plan 2 of 3
                    breakpoints: {
                        375: {
                            slidesPerView: 1,
                            spaceBetween: 64,
                            enabled: true
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 32,
                            enabled: false
                        },
                    },

                } );

                pricingSliderInstance.on( "activeIndexChange", function () {

                    const menuButtons = document.querySelectorAll( ".pricing-plan-menu .button" );
                    const featuresList = document.querySelector( ".ce-pricing-plans-features-list" );

                    let index = 0;

                    for ( const button of menuButtons ) {
                        button.classList.remove( "active" );

                        if ( pricingSliderInstance.activeIndex === index ) {
                            button.classList.add( "active" );

                            if ( featuresList ) {

                                const allPlanTableCells = document.querySelectorAll( ".pricing-plan" );

                                for ( const cell of allPlanTableCells ) {
                                    cell.style.display = "none";
                                }

                                const activePlanTableCells = document.querySelectorAll( "." + button.getAttribute( "data-plan" ) );

                                for ( const cell of activePlanTableCells ) {
                                    cell.style.display = "table-cell";

                                }

                            }

                        }

                        index++;

                    }

                } );

                const featuresList = document.querySelector( ".ce-pricing-plans-features-list" );
                const featuredPlans = document.querySelector( ".ce-featured-pricing-plans" );

                if ( featuredPlans ) {

                    let scrollY = 0;
                    let ticking = false;

                    document.addEventListener( "scroll", () => {
                        scrollY = window.scrollY;

                        if ( !ticking ) {
                            window.requestAnimationFrame( () => {
                                showPlanMenu( scrollY );
                                ticking = false;
                            } );
                            ticking = true;
                        }
                    } )

                    const showPlanMenu = ( scrollY ) => {

                        const mainHeader = document.querySelector( ".main-header" );
                        const planMenu = document.querySelector( ".pricing-plan-menu" );

                        if ( scrollY >= mainHeader.clientHeight ) {

                            if ( !planMenu.classList.contains( "show" ) ) {
                                planMenu.style.top = mainHeader.clientHeight + "px";
                                planMenu.classList.add( "show" );
                            }

                        }

                        if ( featuresList ) {

                            if ( scrollY === 0 || featuresList.getBoundingClientRect().bottom <= 0 ) {

                                if ( planMenu.classList.contains( "show" ) ) {
                                    planMenu.style.top = 0;
                                    planMenu.classList.remove( "show" );
                                }

                            }

                        } else if ( featuredPlans ) {

                            if ( scrollY === 0 || featuredPlans.getBoundingClientRect().bottom <= 0 ) {

                                if ( planMenu.classList.contains( "show" ) ) {
                                    planMenu.style.top = 0;
                                    planMenu.classList.remove( "show" );
                                }

                            }

                        }

                    }

                    const buttons = document.querySelectorAll( ".pricing-plan-menu .button" );

                    for ( const button of buttons ) {

                        button.addEventListener( "click", function () {

                            pricingSliderInstance.slideTo( this.getAttribute( "data-slide" ) );

                            const buttons = document.querySelectorAll( ".pricing-plan-menu .button" );

                            for ( const button of buttons ) {
                                button.classList.remove( "active" );
                            }
                            this.classList.add( "active" );

                            const plans = document.querySelectorAll( ".pricing-plan" );
                            for ( const plan of plans ) {
                                plan.style.display = "none";
                            }

                            const active_plan = this.getAttribute( "data-plan" );
                            const active_plans = document.querySelectorAll( "." + active_plan );

                            for ( const plan of active_plans ) {
                                plan.style.display = "table-cell";
                            }

                        } )

                    }

                    const updateTable = () => {

                        const allPlanTableCells = document.querySelectorAll( ".pricing-plan" );

                        if ( document.body.clientWidth > 1024 ) {

                            for ( const cell of allPlanTableCells ) {
                                cell.style.display = "table-cell";
                            }

                        } else {

                            for ( const cell of allPlanTableCells ) {
                                cell.style.display = "none";
                            }

                            const activePlanTableCells = document.querySelectorAll( ".pricing-plan-" + ( pricingSliderInstance.activeIndex + 1 ) );

                            for ( const cell of activePlanTableCells ) {
                                cell.style.display = "table-cell";
                            }

                        }

                    }

                    const updateButtonMenu = () => {

                        const buttons = document.querySelectorAll( ".pricing-plan-menu .button" );

                        let index = 0;

                        for ( const button of buttons ) {

                            button.classList.remove( "active" );

                            if ( pricingSliderInstance.activeIndex === index ) {

                                button.classList.add( "active" );

                            }

                            index++;

                        }
                    }

                    window.addEventListener( 'resize', () => {

                        updateTable();
                        updateButtonMenu();

                    } )

                    updateTable();
                    updateButtonMenu();

                }

            }

        }

    }

    async reviewsSlider() {

        let reviewsSlider = document.querySelectorAll( '.ce-reviews' );

        if ( reviewsSlider.length > 0 ) {
            const {Swiper, Navigation} = await import( 'swiper' );

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for ( let slider of reviewsSlider ) {

                new Swiper( slider.querySelector( '.swiper' ), {
                    modules: [Navigation],
                    loop: false,
                    slidesPerView: 1.1,
                            spaceBetween: 16,
                    centeredSlides: true,
                    speed: 600,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector( '.swiper-button-next' ),
                        prevEl: slider.querySelector( '.swiper-button-prev' )
                    },
                    breakpoints: {
                        375: {
                            slidesPerView: 1.25,
                            spaceBetween: 24,
                            centeredSlides: true,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                            centeredSlides: false,
                        },
                    },
                } );

            }

        }

    }

    async topArticlesSlider() {

        const topArticlesSlider = document.querySelector( '.ce-keyvisual-slider.ce-keyvisual-slider--top-articles .swiper' );

        if ( topArticlesSlider ) {
            const {Swiper, Autoplay, Pagination} = await import( 'swiper' );

            new Swiper( topArticlesSlider, {
                    modules: [Pagination, Autoplay],
                spaceBetween: 100,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: ".swiper-pagination",
                },
            } );

        }

    }

}

module.exports = Slider;
